import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import generalSlice from '../../../store/general/GeneralSlice';

export default function ModalVersion() {
    const { versionModal } = useSelector((state: any) => state.general);
    const dispatch = useDispatch();

    const reloadVersion = () => {
        window.location.reload();
        dispatch(generalSlice.actions.setVersionModal(false));
    };

    return (
        <Modal
            show={versionModal}
            className="modal-dark"
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered={true}
        >
            <Modal.Body>
                <p className="text-center">
                    The new version of influence.vision is now live! Please reload the page by clicking the button below
                    to get the latest updates and data.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={reloadVersion} className="btn-sm w-100">
                    Refresh page
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
